import { api } from "lib";

export const getPendingLeaveRequest = async (params = {}) => {
    return await api.post("/v1/requestApprove/getLeaveRequestApprovePaging", params);
};

export const getWorkflowByRequestId = async (params) => {
    return await api.post("/v1/leaveRequest/getWorkflowByRequestId", params);
};
